export const httpStatusList = {
	ok:                  200,
	noContent:           204,
	badRequest:          400,
	unauthorized:        401,
	forbidden:           403,
	notFound:            404,
	requestTimeout:      408,
	internalServerError: 500,
};

export const GetErrorMessage = (httpStatusCode) =>
{
	switch (httpStatusCode)
	{
	case httpStatusList.noContent:
		return "Não há dados no período selecionado.";
	case httpStatusList.unauthorized:
		return "Não foi possível verificar suas credenciais. Por fazer, refaça o login no sistema e tente novamente.";
	case httpStatusList.badRequest:
		return "Houve um erro no envio dos parâmetros. Por favor, tente novamente.";
	case httpStatusList.notfound:
		return "Não foi possível encontrar os dados solicitados. Por favor, tente novamente.";
	case httpStatusList.internalServerError:
		return "Houve um erro no servidor. Por favor, reporte o problema e tente novamente mais tarde.";
	case httpStatusList.forbidden:
		return "O usuário logado não possui autorização para executar esta ação.";
	case httpStatusList.requestTimeout:
		return "O servidor demorou muito para responser. Por favor, tente novamente mais tarde.";
	default:
		break;
	}
	return "";
};
